import React, { useRef } from "react";
import "./css/index.css";
import { useNavigate } from "react-router-dom";
import { BiHomeAlt, BiPalette, BiHistory, BiUpload } from "react-icons/bi"; // Modern icons
import { FAQSection } from "./faq"
import { Footer } from "./footer"

export const Homepage = () => {
    const navigate = useNavigate();
    const demoSection = useRef()
    const scrollToDemo = () => {
    demoSection.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
    });
    };


    return (
        <div>
            <section className="hero">
                <div className="hero-content">
                    <div className="hero-pill">
                        <BiPalette style={{ marginRight: "3px", marginTop: "0px"}} /> 
                        <p>Design smarter — No account needed</p>
                    </div>

                    <h1 className="hero-heading">
                        WorldPaint Builds Stunning
                        <br />
                        <p className="highlight-line">color experiences</p>
                        <br />
                        effortlessly
                    </h1>

                    <p className="hero-text">
                        Discover curated color combinations tailored for modern digital products,
                        brand identities, and creative projects. Generate instantly and export
                        in formats ready for development.
                    </p>

                    <div className="hero-actions">
                        <button onClick={() => navigate("/")} className="primary-btn">
                            Launch Generator
                        </button>
                        <button onClick={scrollToDemo} className="outline-btn">
                            Explore Demo →
                        </button>
                    </div>
                </div>
            </section>
<section ref={demoSection} className="demo-section">
  <div className="demo-header">
    <div className="hero-pill">
      <BiPalette style={{ marginRight: "4px" }} /> LIVE DEMO
    </div>
    <h2>See WorldPaint in Action</h2>
    <p>A preview of the real-time palette generator interface.</p>
  </div>

  <div className="demo-browser">
    {/* Fake Browser Top Bar */}
    <div className="demo-url-bar">
      <div className="browser-dots">
        <span className="dot red"></span>
        <span className="dot yellow"></span>
        <span className="dot green"></span>
      </div>
      <div className="url-text">
        https://worldpaint.vercel.app/9BAD53-E6C88C-5CEB3A-96694B-3F346E
      </div>
    </div>

    {/* Demo Image */}
    <div className="demo-image-wrapper">
      <img
        src="/demo.png"
        alt="WorldPaint Generator Demo"
        className="demo-image"
      />
    </div>
  </div>
</section>
            <section className="features">
                <div className="features-header">
                    <div className="hero-pill">
                        <BiHomeAlt style={{ marginRight: "4px" }} /> FEATURES
                    </div>
                    <h2>Everything You Need</h2>
                    <p>Professional color tools designed for speed and simplicity.</p>
                </div>

                <div className="features-grid">
                    <div className="feature-card">
                        <BiUpload className="feature-icon" />
                        <h3>Instant Generation</h3>
                        <p>Press spacebar to generate harmonious palettes instantly. Each uses intelligent color-theory algorithms.</p>
                    </div>

                    <div className="feature-card">
                        <BiPalette className="feature-icon" />
                        <h3>Lock & Iterate</h3>
                        <p>Lock colors you love, regenerate the rest. Build your perfect palette one color at a time.</p>
                    </div>

                    <div className="feature-card">
                        <BiHistory className="feature-icon" />
                        <h3>Shade Picker</h3>
                        <p>Fine-tune any color with up to 20 lighter and darker variations while maintaining harmony.</p>
                    </div>

                    <div className="feature-card">
                        <BiHomeAlt className="feature-icon" />
                        <h3>WCAG Contrast Checker</h3>
                        <p>Instant AA and AAA contrast ratios for every color against black and white text.</p>
                    </div>

                

                    <div className="feature-card">
                        <BiPalette className="feature-icon" />
                        <h3>6 Harmony Modes</h3>
                        <p>Auto, Monochromatic, Analogous, Complementary, Split Complementary, and Triadic.</p>
                    </div>
                </div>
            </section>
<section className="how-it-works">
  <div className="how-header">
    <div className="hero-pill">
      <BiPalette style={{ marginRight: "4px" }} /> HOW IT WORKS
    </div>
    <h2>Simple steps to create and export stunning color palettes</h2>
    <p>Follow these steps to generate, customize, and export palettes effortlessly.</p>
  </div>

  <div className="how-steps">
    <div className="how-step">
      <div className="step-number">1</div>
      <h3>Generate a Palette</h3>
      <p>Press the spacebar to generate a new palette of harmonious colors instantly.</p>
    </div>

    <div className="how-step">
      <div className="step-number">2</div>
      <h3>Lock & Customize</h3>
      <p>Lock the colors you love and adjust the rest using the shade picker to fine-tune your palette.</p>
    </div>

    <div className="how-step">
      <div className="step-number">3</div>
      <h3>Export & Share</h3>
      <p>Export your palette in CSS, Tailwind, SCSS, JSON, design tokens, or PNG/SVG for any workflow.</p>
    </div>
  </div>
  
</section>
<div className="try-it-out-container">
  <button
    className="try-it-out-btn"
    onClick={() => navigate("/")} // goes to generator page
  >
    Try It Out →
  </button>
</div>
            {/* Export Section */}
            <section className="export-section">
                <div className="export-header">
                    <div className="hero-pill">
                        <BiUpload style={{ marginRight: "4px" }} /> EXPORT TO ANY FORMAT
                    </div>
                    <h2>From CSS variables to social-media images, ready for your workflow.</h2>
                </div>

                <div className="export-grid">
                    <div className="export-card">
                        <h3>CSS Variables</h3>
                        <p>Custom properties for any stylesheet.</p>
                        <pre>
{`:root {
  --deep-teal: #2A5B6C;
  --coral: #E8846B;
  --cream: #F5F0E8;
}`}
                        </pre>
                    </div>

                    <div className="export-card">
                        <h3>Tailwind CSS</h3>
                        <p>v4 @theme or v3 config with smart naming.</p>
                        <pre>
{`@theme {
  --color-deep-teal: #2A5B6C;
  --color-coral: #E8846B;
  --color-cream: #F5F0E8;
}`}
                        </pre>
                    </div>

                  <div className="export-card">
  <h3>CSS</h3>
  <p>Custom properties for your palette.</p>
  <pre>
{`:root {
  --deep-teal: #2A5B6C;
  --coral: #E8846B;
}`}
  </pre>
</div>

                    <div className="export-card">
                        <h3>JSON</h3>
                        <p>Full metadata: HEX, RGB, HSL, OKLCH.</p>
                        <pre>
{`{
  "palette": [{
    "name": "deep-teal",
    "hex": "#2A5B6C",
    "oklch": { "l": 42, "c": 0.08, "h": 210 }
  }]
}`}
                        </pre>
                    </div>

<div className="export-card">
  <h3>URL</h3>
  <p>Palette link to share or use.</p>
  <pre>
{`https://worldpaint.vercel.app/#2A5B6C-E8846B-...`}
  </pre>
</div>

                    <div className="export-card">
                        <h3>PNG / SVG</h3>
                        <p>1200×630 social image or vector graphic with color names.</p>
                    </div>
                </div>
            </section>
            <FAQSection />
            <Footer />
        </div>
    );
};